import React, { useEffect } from 'react';
import Button from './Button';
import IntegerInput from './IntegerInput';
import { MoldsPropType } from '../helpers/prop-types';
import PropTypes from 'prop-types';
import SiliconeMoldPicker from './SiliconeMoldPicker/SiliconeMoldPicker';
import { saveToStorage } from '../helpers/storage';
import styles from './MoldContainer.module.scss';
import useDebouncedEffect from '../hooks/use-debounced-effect';
import useLocalize from '../hooks/use-localize';
import useToggle from '../hooks/use-toggle';

const MoldSilicone = ({ molds, setMoldUrl, setVolume, side, volume }) => {
  const { localize } = useLocalize();
  const [isVisible, toggle] = useToggle();

  useEffect(() => {
    saveToStorage(`${side}-type`, 'silicone');
  }, []);

  useDebouncedEffect(() => setMoldUrl(volume.toString()), [volume]);

  return (
    <div className={styles.grid}>
      <div>{localize('mold.volume')}</div>
      <div />
      <div className={`${styles.volume} ${styles.flex}`}>
        <Button handleOnClick={toggle} isSmall>
          {localize('mold.choose')}
        </Button>
        <IntegerInput max='100000' min='1' onChange={setVolume} value={volume} />
      </div>
      {isVisible && <SiliconeMoldPicker hide={toggle} molds={molds} setVolume={setVolume} />}
    </div>
  );
};

MoldSilicone.propTypes = {
  molds: MoldsPropType.isRequired,
  setMoldUrl: PropTypes.func.isRequired,
  setVolume: PropTypes.func.isRequired,
  side: PropTypes.string.isRequired,
  volume: PropTypes.number.isRequired,
};

export default MoldSilicone;
